import { useMutation } from 'react-query';
import api from '~/services/api';
import { parseResponseData } from '../../../../services/utils/parseResponseData';

export const useDeleteTeam = options =>
  useMutation(
    id => api.delete(`/squad/${id}/`).then(parseResponseData),
    options
  );
